<template>
    <div>
        <h2>Source Code</h2>
        <prism-editor v-model="code" line-numbers/>

        <h2 class="mt-4 d-flex align-center">
            <span>Replaced</span>
            <span>
                <v-radio-group v-model="type" inline hide-details>
                    <v-radio label="Line" value="line" />
                    <v-radio label="Array" value="array" />
                </v-radio-group>
            </span>
        </h2>
        <v-sheet border width="100%" height="500">
            <textarea :value="replaced" length="50" style="width: 100%; height: 100%" />
        </v-sheet>
    </div>
</template>

<script>
import prismEditor from '@/components/developer/prism-editor.vue';

export default {
    components: {
        prismEditor
    },
    data(){
        return {
            code: "",

            type: "line" || "array"
        }
    },
    computed: {
        replaced(){
            switch(this.type){
                case "line": return JSON.stringify(this.code).replace(/`/g, "\\`").replace(/^\"/, "`").replace(/\"$/, "`").replace(/\/script/, "\\/script");
                case "array": return JSON.stringify(this.code).replace(/`/g, "\\`").replace(/((\\n)+)/g, "$1`,\n`").replace(/^\"/, "[\n`").replace(/\"$/, "`\n]").replace(/\/script/, "\\/script");
            }
            
        }
    }
}
</script>